import { applyDiffs } from '@colonist/game-state-types';
export class UIGameState {
    applyStateUpdates(stateUpdate) {
        applyDiffs(this.state, stateUpdate);
    }
    constructor(state){
        this.state = state;
    }
}
